import request from "@/request"

/**
 * 获取文章的所有评论
 */
export function findCommentListByArticleId(id) {
    return request({
        url: `/comments/article/${id}`,
        method: 'GET'
    })
}

/**
 * 发布评论
 */
export function publishComment(comment, token) {
    return request({
        headers: {'Authorization': token},
        url: "/comments/create/change",
        method: "POST",
        data: comment
    })
}
 